import { apiBaseURL, assetsDetailsV2ActionType, toastifyType } from "../../constants";
import { setLoading } from "./loadingAction";
import apiConfig from '../../config/apiConfig';
import { addTost } from "./toastAction";



export const fetchAssetsHistory = (id, setHistory, seIsLoading) => async (dispatch) => {
    // dispatch(setLoading(true))]
    seIsLoading && seIsLoading(true)
    try {
        const response = await apiConfig.get(apiBaseURL.ASSETS_DETAILS + '/' + id + '/history')
        dispatch({ type: assetsDetailsV2ActionType.FETCH_ASSETS_HISTORY_V2, payload: response.data?.data });
        setHistory && setHistory(response.data?.data)
        seIsLoading && seIsLoading(false)
        dispatch(setLoading(false))
    } catch (error) {
        dispatch(setLoading(false))
        seIsLoading && seIsLoading(false)
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }))
    }
}